import {IImomoError, IRequestResetPasswordData} from '../api/api.types';
import {ILoginService} from '../auth/login.service';
import {StateService} from 'angular-ui-router';
import {RequestAccessDialog} from './request-access-dialog.controller';
import {RequestResetPasswordDialog} from './request-reset-password-dialog.controller';
import {AppSetupDialog} from './app-setup-dialog.controller';
import RequestAccessApi from '../api/request-access-api.service';
import {IUserApi} from '../api/user-api.service';
import IOrganizationApi from '../api/organization-api.service';
import {IImomoErrorService} from '../error/error.service';
import {IOrganizationEvents} from '../hydromet/organization/organization.controller'

export interface ILoginDetails {
  username:string,
  password:string
}

export interface INewUserData {
    organizationName: string;
    address: string;
    username: string;
    email: string;
    phone: number;
}

const requestResetPasswordDialogTemplate = require<string>(
    './request-reset-password-dialog.html');
const requestAccessDialogTemplate = require<string>(
    './request-access-dialog.html');
const appSetupDialogTemplate = require<string>(
    './app-setup-dialog.html');

export default class LoginCardController {
  static $inject = ['loginService', '$state', '$log',
    '$translate', '$window', '$mdDialog', 'userApi', 'requestAccessApi', '$rootScope', 'organizationApi', 'imomoErrorService'];

  loginDetails:ILoginDetails;
  loginErrorMessage:string;

  private logInInProgress:boolean;
  private organizationsPromise:ng.IPromise<void>;

  constructor(private loginService:ILoginService,
              private $state:StateService,
              private $log:ng.ILogService,
              private $translate:ng.translate.ITranslateService,
              private $window: ng.IWindowService,
              private $mdDialog: ng.material.IDialogService,
              private userApi: IUserApi,
              private requestAccessApi: RequestAccessApi,
              private $rootScope: ng.IRootScopeService,
              private organizationApi: IOrganizationApi,
              private imomoErrorService: IImomoErrorService
              ) {
    
    this.loginDetails = {
      username: null,
      password: null
    };

    this.logInInProgress = false;
  }

  logIn() {
    this.logInInProgress = true;
    this.loginErrorMessage = null;
    this.loginService.logInUser(
        this.loginDetails.username,
        this.loginDetails.password
    ).then(() => {
      this.$rootScope.$broadcast(ILoginService.LOGIN_EVENT_NAME);
      this.userApi.getCurrentUser()
        .then(data => {
        	this.$window.localStorage.setItem('currentOrgId', data.sourceId);
          this.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);
          this.organizationApi.getOrganization(data.sourceId)
            .then((data) => {
                if (data.setupFinished) {
                    this.$state.go('home');  
                } else {
                  this.$mdDialog.show({
                    template: appSetupDialogTemplate,
                    controller: AppSetupDialog,
                    bindToController: true,
                    controllerAs: '$ctrl'
                  }).then(() => {
                    
                  });
                }
            });
        	
        });
    }).catch((error) => {
      this.imomoErrorService.showErrorDetailsDialog(this.$translate.instant('USERNAME_OR_PASSWORD_WRONG'));
      if (error.data) {
        this.onLoginError(error.data);
      }
    }).finally(() => {
      this.logInInProgress = false;
    });
  };

  requestAccess($event: MouseEvent) {
    const self = this;
    this.$mdDialog.show({
      targetEvent: $event,
      template: requestAccessDialogTemplate,
      controller: RequestAccessDialog,
      bindToController: true,
      controllerAs: '$ctrl'
    }).then((userData: INewUserData) => {
      this.requestAccessApi.sendAccessData(userData).then(
        () => {}, 
        (errorData)=>{
        self.$mdDialog.show(
            self.$mdDialog.alert()
                .clickOutsideToClose(true)
                .title('Save failed')
                .textContent(errorData.data.details)
                .ok('OK')
                .targetEvent($event)
         );
      });
    });
  }

  requestResetPassword($event: MouseEvent) {
    this.$mdDialog.show({
      targetEvent: $event,
      template: requestResetPasswordDialogTemplate,
      controller: RequestResetPasswordDialog,
      bindToController: true,
      controllerAs: '$ctrl'
    }).then((data: IRequestResetPasswordData) => {
      this.userApi.requestResetPassword(data);
    });
  }

  private onLoginError(error:IImomoError) {
    this.$translate(`API.ERRORS.${error.errorType}_${error.errorCode}`)
        .then((translatedMessage) => {
          this.loginErrorMessage = translatedMessage;
          this.loginDetails.password = '';
          this.$log.error(this.loginErrorMessage);
        })
  };

}



/** WEBPACK FOOTER **
 ** ./app/login/login-card.controller.ts
 **/